window.addEventListener('scroll', function () {
    var header = document.querySelector('.viair-header-header');
    if (window.scrollY > 20) {
        header.classList.add('sticky-header');
    } else {
        header.classList.remove('sticky-header');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const firstLevelLinks = document.querySelectorAll('.viair-header-link-first-level');
    let timeoutId;

    firstLevelLinks.forEach(link => {
        link.addEventListener('mouseover', function () {
            // Clear any existing timeouts to prevent unwanted class removal
            clearTimeout(timeoutId);

            // Remove 'collapse-mega-menu' from all mega menus
            document.querySelectorAll('.viair-header-mega-menu.collapse-mega-menu').forEach(menu => {
                menu.classList.remove('collapse-mega-menu');
            });

            // Add 'collapse-mega-menu' to the current mega menu
            const megaMenu = link.querySelector('.viair-header-mega-menu');
            if (megaMenu) {
                megaMenu.classList.add('collapse-mega-menu');
            }
        });

        link.addEventListener('mouseleave', function () {
            const megaMenu = link.querySelector('.viair-header-mega-menu');
            if (megaMenu) {
                // Set a timeout to remove the class after 300ms
                timeoutId = setTimeout(() => {
                    megaMenu.classList.remove('collapse-mega-menu');
                }, 500);
            }
        });
    });
});


const firstLevelElements = document.querySelectorAll('.viair-header-link-first-level');

firstLevelElements.forEach(firstLevel => {
    // Select li elements within the current firstLevel element
    const liElements = firstLevel.querySelectorAll('.viair-header-link-second-level-li');

    liElements.forEach(li => {
        document.querySelector('.viair-header-top-level-menu-image-url').classList.remove('shrinkedImage');
        li.addEventListener('mouseenter', function () {

            const dataTitle = this.querySelector('[data-title]').getAttribute('data-title');

            const dataShrink = li.querySelector('.shrinkedImage--yes');
            // Find the imageElement within the current firstLevel
            const imageElement = firstLevel.querySelector('.viair-header-top-level-menu-image .viair-header-top-level-menu-image-url');

            if (dataTitle && imageElement) {
                imageElement.setAttribute('image-data-scnd', dataTitle);

                const parentElement = imageElement.closest('a.viair-header-top-level-menu-image-url');
                // console.log(dataShrink)
                if (dataShrink !== null) {
                    parentElement.classList.add('shrinkedImage');
                } else {
                    document.querySelector('.viair-header-top-level-menu-image-url').classList.remove('shrinkedImage');
                }
            } else if (imageElement) {
                imageElement.removeAttribute('image-data-scnd');
            }
        });

        li.addEventListener('mouseleave', function () {
            document.querySelector('.viair-header-top-level-menu-image-url').classList.remove('shrinkedImage');
        })
    });

    firstLevel.addEventListener('mouseenter', function () {
        const imageElement = firstLevel.querySelector('.viair-header-top-level-menu-image .viair-header-top-level-menu-image-url');
        if (imageElement && imageElement.hasAttribute('image-data-scnd')) {
            imageElement.removeAttribute('image-data-scnd');
        }
    });
});




const secondLevelElements = document.querySelectorAll('.viair-header-link-second-level-li');
const topMenuImageElement = document.querySelector('.viair-header-top-level-menu-image .viair-header-top-level-menu-image-url');
const topMenuTextElement = document.querySelector('.viair-header-top-level-menu-image .btn__text');
const topMenuAnchorElement = document.querySelector('.viair-header-top-level-menu-image .viair-header-top-level-menu-image-url');

// Store default values
const defaultHref = topMenuAnchorElement.getAttribute('href');

secondLevelElements.forEach(element => {
    element.addEventListener('mouseenter', function () {
        const imageUrl = this.querySelector('[image-url]')?.getAttribute('image-url');

        if (imageUrl) {
            if (topMenuAnchorElement) {
                topMenuAnchorElement.href = imageUrl;
            }
        } else {
            if (topMenuAnchorElement) {
                topMenuAnchorElement.href = defaultHref;
            }
        }
    });
});

firstLevelElements.forEach(element => {
    element.addEventListener('mouseenter', function () {
        if (topMenuAnchorElement) {
            topMenuAnchorElement.href = defaultHref;
        }
        if (topMenuTextElement) {
            topMenuTextElement.textContent = defaultText;
        }
    });
});



window.addEventListener("load", (event) => {


    /* Hamburger */
    document.querySelector('.js-hamburger').addEventListener('click', function () {
        document.querySelector('body').classList.toggle('overflow-hidden');
        this.classList.toggle('site-header__hamburger--active');
        this.closest('.site-header').classList.toggle('site-header--open');
        document.querySelector('.navigation-mobile').classList.toggle('navigation-mobile--active');
    });

    let dropdown = document.querySelector('.navigation-mobile');
    let items = dropdown.querySelectorAll('.navigation-mobile__list-item--has-dd');
    items.forEach(item => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            slideAnim(e);
        });
    });



    function slideAnim(e) {
        let el = e.currentTarget;
        let body = el.querySelector('.navigation-mobile__dropdown');
        let active = document.querySelector('.navigation-mobile__list-item--active');
        // if (active) {
        //     active.classList.remove('navigation-mobile__list-item--animate');
        //     active.querySelector('.navigation-mobile__dropdown').addEventListener('transitionend', () => {
        //         active.classList.remove('navigation-mobile__list-item--active')
        //     }, { once: true })
        // }
        if (!el.classList.contains('navigation-mobile__list-item--active')) {
            el.classList.add('navigation-mobile__list-item--active', 'navigation-mobile__list-item--animate');
        } 
        //else {
        //     el.classList.remove('navigation-mobile__list-item--animate');
        //     body.addEventListener('transitionend', () => {
        //         el.classList.remove('navigation-mobile__list-item--active');
        //     }, { once: true })
        // }
    }
    const dropdownBack = document.querySelectorAll('.dropdown_back');

    // Add click event listener for each dropdown back button
    dropdownBack.forEach(button => {
        button.addEventListener('click', (event) => {
            // Stop the event from propagating
            event.stopPropagation();

            const activeItem = button.closest('.navigation-mobile__list-item--active');
            if (activeItem) {
                activeItem.classList.remove('navigation-mobile__list-item--animate', 'navigation-mobile__list-item--active');
            }
        });
    });

    // Annoucement bar slider
    const announcementSlideItems = document.querySelectorAll('.announcement-bar');

    announcementSlideItems.forEach(item => {
        const announcementSlide = new Swiper(item, {
            wrapperClass: 'announcement-bar__track',
            slideClass: 'announcement-bar__item',
            autoHeight: true,
            speed: 500,
            slidesPerView: 'auto',
            autoplay: {
                disableOnInteraction: false,
                delay: 5000
            }
        });
    });

});

const arrows = document.querySelectorAll('.small_mega_scnd_menu_link__arrow');

// Add a click event listener to each element
arrows.forEach(arrow => {
    arrow.addEventListener('click', () => {
        // Toggle the class on the clicked element
        arrow.classList.toggle('collapse_third_level_menu');

        // Find the common parent li element
        const parentLi = arrow.closest('.navigation-mobile__dropdown-item');

        // Find the sibling element with the specified class within the common parent
        const siblingElement = parentLi.querySelector('.viair-header-mobile_second-level-navigation-mobile__dropdown-item');

        // Check if the sibling element exists
        if (siblingElement) {
            // Toggle the class on the sibling element
            siblingElement.classList.toggle('collapse_third_level_menu');
        }
    });
});

$('.viair-header-link-first-level').hover(function() {
    $(this).addClass('hover-active');
}, function() {
    $(this).removeClass('hover-active');
});

$('.viair-header-mega-menu').hover(function() {
    $(this).closest('.viair-header-link-first-level').addClass('hover-active');
}, function() {
    $(this).closest('.viair-header-link-first-level').removeClass('hover-active');
});


$('.viair-header-link-second-level-li').hover(function() {
    $(this).addClass('hover-active-white');
}, function() {
    $(this).removeClass('hover-active-white');
});

$('.viair-header-link-third-level-container').hover(function() {
    $(this).closest('.viair-header-link-second-level-li').addClass('hover-active-white');
}, function() {
    $(this).closest('.viair-header-link-second-level-li').removeClass('hover-active-white');
});


// First item of second menu level open
const topLevelShopItem = document.querySelector('.top_level_shop');

const compressorItem = topLevelShopItem.querySelector('.second_level_compressors');

const secondLevelItems = topLevelShopItem.querySelectorAll('.viair-header-link-second-level-li');

function addClassToCompressor() {
    secondLevelItems.forEach(item => item.classList.remove('second_level_collapse'));
    compressorItem.classList.add('second_level_collapse');
}

function handleSecondLevelHover(e) {
    e.stopPropagation();
    if (!this.classList.contains('second_level_shop-all')) {
        secondLevelItems.forEach(item => item.classList.remove('second_level_collapse'));
        this.classList.add('second_level_collapse');
    }
}

topLevelShopItem.addEventListener('mouseover', (e) => {
    if (e.currentTarget === e.target) { 
        addClassToCompressor();
    }
});

secondLevelItems.forEach(item => {
    item.addEventListener('mouseover', handleSecondLevelHover);
});

